<template>
  <VideoModal :title="title" :link="link" @close="link = ''"></VideoModal>
  <div class="container">
        <img src="@/assets/images/news_banner.png" class="img-fluid"/>
  </div>
  <div class="news container my-5 bg-gray2">
    <h1 class="h2 text-start py-3 px-3">NEWS</h1>
    <div class="row align-items-start">
      <div class="col-lg-4 col-sm-10" v-for="(n, index) in news" :key="index">
        <NewsCard :n="n" @click="showVideo(n)"></NewsCard>
      </div>
    </div>
  </div>
  <!-- 聯絡我們 -->
  <ContactFooter />
</template>
<script>
import VideoModal from "@/components/VideoModal.vue";
import NewsCard from "@/components/NewsCard.vue";
import news from "@/config/news.js"
import ContactFooter from '@/components/ContactFooter.vue'

export default {
  name: "News",
  components: {
    VideoModal,
    NewsCard,
    ContactFooter,
  },
  data() {
    return {
      title: "",
      link: "",
      news: news,
    }
  },
  mounted() {
  window.scrollTo(0, 0);
  },
  methods: {
    showVideo(n) {
      this.title = n.title
      this.link = n.link
    }
  }
};
</script>
<style lang=""></style>
